module.exports = __webpack_public_path__ + "img/myguard_pro_banner_00.f796b38e.jpg";